import ActionsBuilder from '../../../../utils/actions/ActionsBuilder';

export const IDENTIFIER = '[PRODUCTS]';
export default {
  ...ActionsBuilder.buildList(IDENTIFIER)
};
